import { DrawerAction, DrawerState } from './DrawerState';

export const DrawerReducer = (state: DrawerState, action: DrawerAction): DrawerState => {
  switch (action.type) {
    case 'OPEN': {
      const { id, type } = action.payload;
      return {
        drawer: {
          id,
          type,
          open: true,
        },
      };
    }
    case 'CLOSE': {
      return {
        drawer: {
          id: undefined,
          type: undefined,
          open: false,
        },
      };
    }
    default:
      return state;
  }
};
